import { Chip } from '@mui/material'
import { Box } from '@mui/system'
import { enqueueSnackbar } from 'notistack'
import { setDatoSolicitud } from '../solicitudesSlice'

/**
 * Construye el elemento visual que se mostrará en el estado de una solicitud
 * @param {'number'} status - Status de la solicitud
 * @param {'string'} d_status - Descripción del status
 * @param {import('@mui/material').SxProps<import('@mui/system').Theme>} sx - Descripción del status
 * @param {import('@mui/material').SxProps<import('@mui/system').Theme>} sxBox - Descripción del status
 * @returns {import("@mui/material").ChipClasses}
 */
export const getChipSolicitud = (status, d_status, sx = {}, sxBox = {}) => {
  let color = 'warning'
  if (status === 200 || status === 201) {
    color = 'warning'
  } else if (status === 300) {
    color = 'info'
  } else if (status === 500) {
    color = 'success'
    if (!d_status) {
      d_status = 'Aprobada parcial'
    }
  } else if (status % 2 === 0) {
    color = 'warning'
    if (!d_status) {
      d_status = 'Aprobada parcial'
    }
  } else if (status === 600 || status % 2 === 1) {
    color = 'error'
    if (!d_status) {
      d_status = 'Rechazada'
    }
  }

  return (
    <Box sx={{ p: '0px', display: 'flex', alignItems: 'center', ...sxBox }}>
      <Chip label={d_status} color={color} size="small" sx={{ ...sx }} />
    </Box>
  )
}

/**
 * Construye el elemento visual que se mostrará en el estado de una solicitud
 * @param {'number'} status - Status de la solicitud
 * @param {'string'} d_status - Descripción del status
 * @returns {import("@mui/material").ChipClasses}
 */
export const getPropsBadgeSolicitud = (status, d_status) => {
  let color = 'warning'
  if (status === 200 || status === 201) {
    color = 'warning'
  } else if (status === 300) {
    color = 'info'
  } else if (status === 500) {
    color = 'success'
    if (!d_status) {
      d_status = 'Aprobada parcial'
    }
  } else if (status % 2 === 0) {
    color = 'warning'
    if (!d_status) {
      d_status = 'Aprobada parcial'
    }
  } else if (status === 600 || status % 2 === 1) {
    color = 'error'
    if (!d_status) {
      d_status = 'Rechazada'
    }
  }

  return {
    badgeContent: d_status,
    color,
  }
}

/**
 * Gets the current form input values, excluding file fields (tipo_dato === 'B')
 * @param {Object} datos - Current data object in state (keyed by idpk)
 * @param {Array} campos - Current field array in state
 * @returns {Array} Array of {codigo_campo, valor, tipo} objects
 */
export const getValoresConsulta = (datos, campos) => {
  const valores = []
  for (const idpk in datos) {
    if (Object.hasOwnProperty.call(datos, idpk)) {
      const valor = datos[idpk]
      const field = campos.filter((c) => Number(c.idpk) === Number(idpk))[0]
      // Excluir campos de tipo fichero (B)
      if (field.tipo_dato !== 'B') {
        valores.push({ codigo_campo: field.codigo_campo, valor, tipo: field.tipo_dato })
      }
    }
  }
  return valores
}

/**
 * Comprueba si todos los campos padre de un campo dependiente tienen valor.
 * Replica la misma lógica que CamposSolicitud.jsx usa durante la inicialización.
 * @param {Object} campoDependiente - Campo que depende de otros
 * @param {Array} campos - Array completo de campos
 * @param {Object} datos - Valores actuales (keyed by idpk)
 * @returns {boolean} true si todos los padres tienen valor
 */
export const todosLosPadresTienenValor = (campoDependiente, campos, datos) => {
  const parents = campos.filter(
    (c) => c.tipo_dato !== 'S' && campoDependiente.depende_de.includes(c.codigo_campo),
  )
  return parents.length > 0 && parents.every((p) => datos[p.idpk])
}

/**
 * Procesa el resultado de una validación de campo.
 * Si el resultado es un array de objetos {idpk, valor, mensaje, tipo},
 * actualiza múltiples campos y muestra snackbars si hay mensajes.
 * Si el resultado es un valor simple, actualiza el campo actual.
 *
 * NOTA: Esta función solo procesa resultados exitosos de validate().
 * Los errores de validación se manejan mediante excepciones en el catch del componente.
 *
 * @param {Array|*} result - Resultado de la validación (array de actualizaciones o valor simple)
 * @param {Object} campo - Campo que se está validando
 * @param {*} value - Valor original del campo
 * @param {Function} dispatch - Función dispatch de Redux
 * @param {string} [descripcion] - Descripción opcional para campos de lista
 */
export const processValidationResult = (result, campo, value, dispatch, descripcion) => {
  // Si es un array, procesar múltiples actualizaciones
  if (Array.isArray(result)) {
    result.forEach(({ idpk, valor, mensaje, tipo }) => {
      dispatch(setDatoSolicitud({ idpk, valor }))
      if (mensaje) {
        enqueueSnackbar(mensaje, { variant: tipo || 'success' })
      }
    })
    return
  }

  // Comportamiento original: si el resultado no es true, usarlo como nuevo valor
  if (result !== true) {
    dispatch(setDatoSolicitud({ idpk: campo.idpk, valor: result, descripcion }))
  } else {
    dispatch(setDatoSolicitud({ idpk: campo.idpk, valor: value, descripcion }))
  }
}
